
/**
 * 시스템 설정 
 */
class Config {
    constructor(){
        this.id = ""
        this.appendElementTagId = ""
        this.logo = {
            alt:"",
            src:"",
            style:{ pcMargin: "",moMargin: "", pcWidth:"", pcHeight:"", moWidth:"", moHeight:"" }
        }
        this.provider = {
            version: "",
            separator: "",
            mode: { id: "",  description: ""  },
            type: {  id: "", description: ""  },
            api:{
                naver:{
                    clientId:"",
                    callbackUrl: ""
                }
            },
            order:{
                mode:"",
                description:"",
                list:[]
            },
            unUseIdList: []
        }
        this.uriScheme = {
            universalLink: false,
            mode: { id: "",  description: ""  }
        }
        this.url = {
            api: {
                contextPath: "",
                providerListPath: "",
                requestPath: "",
                successPath: "",
            },
            jsp: {
                contextPath: "",
                providerListPath: "",
                tokenPath: "",
                parseTokenPath: "",
                parseSignPath : "",
                providerListPath: "",
                requestPath: "",
                successPath: ""
            }
        }
        this.template = {
            pcTitle:"",
            moTitle:"",
            view_policy1:{title:"",hidden:true,path:""},
            view_policy2:{title:"",hidden:true,path:""},
            view_policy3:{title:"",hidden:true,path:""},
            view_policy4:{title:"",hidden:true,path:""}
        }
        this.userInfo = {
            base64: false
        }
        this.file = {
            guide:{description:"",path:""}
        }
        this.mTranskey = {
            use: false
        }
        this.system = {
            console_debug: "",
            alert_debug: ""
        }
    }

    setConfig(json){
		this.id = json.id;
		this.appendElementTagId = "#"+json.appendElementTagId;
		this.logo = json.logo;
		this.provider = json.provider;
        this.uriScheme = json.uriScheme;
		this.url = json.url;
        this.userInfo = json.userInfo;
        this.template = json.template;
        this.file = json.file;
        this.mTranskey = json.mTranskey;
		this.system = json.system;
    }
}
export default (new Config);